import { AdvSearchProvider } from "./providers/advSearchCtx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Main from "./views/Main";
import { useEffect, useState } from "react";
import { Logo } from "./utils/confs";
import Mobile from "./views/Mobile";
import { useMediaQuery } from "react-responsive";

// Create a client
const queryClient = new QueryClient();
function App() {
  const [isAppReady, setIsAppReady] = useState(false);
  const isDesktopOrLaptop = useMediaQuery({ minWidth: 1000 });
  const isMobile = useMediaQuery({ maxWidth: 900 });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsAppReady(true);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  if (!isAppReady) {
    return (
      <div class="app-spinner" id="app-spinner">
        <div class="uk-text-center">
          <div class="homeprime-spinner__icon">
            <img src={Logo} alt="Loading..." />
          </div>
          <div uk-spinner=""></div>
        </div>
      </div>
    );
  }
  return (
    <QueryClientProvider client={queryClient}>
      <AdvSearchProvider>
        {isDesktopOrLaptop && <Main />}
        {isMobile && <Mobile />}
      </AdvSearchProvider>
    </QueryClientProvider>
  );
}

export default App;
